"use client";

import { c as _c } from "react/compiler-runtime";
import GridColumn from "@/components/common/grid-column/grid-column";
import GridRow from "@/components/common/grid-row/grid-row";
import { ReactNode, useEffect, useState } from "react";
import SuperTitle from "../common/supertitle/supertitle";
import Image from "../common/image/image";
import { ImageLoading } from "@/utilities/imageLoading";
import imageUrl from "@/sanity/utilities/imageUrl";
import LeadershipSection from "./sections/LeadershipSection";
import HomeReviews from "../home/home-reviews/home-reviews";
import Card from "../common/card/card";
import { usePerformance } from "@/contexts/performance-context";
import { AboutPageData } from "@/sanity/interfaces";
import Link from "next/link";
import VideoPlayerModal from "./VideoPlayerModal";
import { PortableText } from "next-sanity";
import StatsCounter from "../common/stats-counter";
import DateString, { DateStringFormat } from "../common/date-string/date-string";
interface IProductProps {
  data: AboutPageData;
  beforeQueryTime: number;
  afterQueryTime: number;
}
const AboutUs = props => {
  const $ = _c(56);
  const {
    data,
    beforeQueryTime,
    afterQueryTime
  } = props;
  const {
    hero,
    featureAbout,
    execFeature,
    leadership,
    testimonials,
    productsGrid,
    careersCta
  } = data;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      marks: {
        highlight: _temp
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const components = t0;
  let t1;
  if ($[1] !== careersCta?.heading) {
    t1 = careersCta?.heading?.split("powerful");
    $[1] = careersCta?.heading;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const careerCtaText = t1;
  const {
    checkTimeElapsed
  } = usePerformance();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  let t2;
  if ($[3] !== testimonials?.items) {
    t2 = () => testimonials?.items?.filter(_temp2) ?? [];
    $[3] = testimonials?.items;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getQuoteItems = t2;
  let t3;
  if ($[5] !== hero?.badges) {
    t3 = () => hero?.badges?.map(_temp3) ?? [];
    $[5] = hero?.badges;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const getHeroBadges = t3;
  const quoteItems = getQuoteItems();
  let t4;
  if ($[7] !== getHeroBadges) {
    t4 = getHeroBadges();
    $[7] = getHeroBadges;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const heroBadges = t4;
  let t5;
  if ($[9] !== afterQueryTime || $[10] !== beforeQueryTime || $[11] !== checkTimeElapsed) {
    t5 = () => {
      checkTimeElapsed(beforeQueryTime, "About page before query started");
      checkTimeElapsed(afterQueryTime, "About page after query completed");
    };
    $[9] = afterQueryTime;
    $[10] = beforeQueryTime;
    $[11] = checkTimeElapsed;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial(prev => (prev + 1) % quoteItems.length);
    }, 4000);
    return () => clearInterval(timer);
  }, t7);
  const t8 = "gap-16";
  const t9 = "relative bg-[linear-gradient(180deg,rgba(250,251,251,0)_0%,#EAF3FF_100%)] pb-24 pt-8 lg:pt-[88px]";
  const T0 = GridRow;
  const t10 = "!self-stretch lg:!gap-20";
  const t11 = hero?.eyebrow;
  let t12;
  if ($[15] !== t11) {
    t12 = <SuperTitle className="mb-4">{t11}</SuperTitle>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== hero?.heading) {
    t13 = hero?.heading ?? [];
    $[17] = hero?.heading;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13) {
    t14 = <h1 className="product-title text-[28px] font-semibold leading-9 text-[#005472] lg:text-[48px] lg:leading-[64px]"><PortableText value={t13} components={components} /></h1>;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t12 || $[22] !== t14) {
    t15 = <div className="max-w-[500px]">{t12}{t14}</div>;
    $[21] = t12;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== hero?.subhead) {
    t16 = hero?.subhead && <p className="text-[18px] leading-7 text-[#696B68]">{hero?.subhead}</p>;
    $[24] = hero?.subhead;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t15 || $[27] !== t16) {
    t17 = <GridColumn lg={6} className="mb-8 flex flex-col items-start gap-8 lg:mb-0">{t15}{t16}</GridColumn>;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const t18 = hero?.images?.[0]?.asset && <GridColumn lg={6} className="relative aspect-[590/596] w-full lg:max-w-[500px]"><Image src={imageUrl(hero.images[0].asset).width(500).url()} className="max:w-[500px] h-auto" alt="About Image" width={1164} height={1176} fetchPriority="high" loading={ImageLoading.EAGER} /><div className="absolute bottom-4 left-0 right-0 overflow-hidden px-8"><div className="flex gap-4 transition-transform duration-500 ease-in-out" style={{
        transform: `translateX(-${currentTestimonial * 340}px)`
      }}>{quoteItems.map(_temp4)}</div></div></GridColumn>;
  let t19;
  if ($[29] !== T0 || $[30] !== t17 || $[31] !== t18) {
    t19 = <div className={t9}><T0 className={t10}>{t17}{t18}</T0></div>;
    $[29] = T0;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== heroBadges) {
    t20 = heroBadges?.length > 0 && <div className="!my-10 lg:!my-16"><GridRow className="flex flex-col items-start gap-[10px] self-stretch"><GridColumn lg={12} className="rounded-[6px] bg-[#004C67]"><StatsCounter items={heroBadges}>{counts => <GridRow>{heroBadges.map((item_1, index_0) => <GridColumn key={index_0} lg={4}><div className="relative flex flex-col items-center justify-center">{index_0 !== heroBadges.length - 1 && <div className="absolute right-0 top-1/2 hidden h-[120px] w-px -translate-y-1/2 bg-white/[0.18] lg:block" />}<div className="flex w-full flex-col items-center justify-center px-4 py-4 lg:p-[55px]"><span className="whitespace-nowrap text-[44px] font-semibold text-white">{item_1.prefix}{counts[index_0]?.toLocaleString()}{item_1.suffix && <span className="text-[#3BD4AE]">{item_1.suffix}</span>}</span><span className="text-sm font-bold uppercase text-white">{item_1.label}</span></div>{index_0 !== heroBadges.length - 1 && <div className="h-px w-[80%] bg-white/[0.18] lg:hidden" />}</div></GridColumn>)}</GridRow>}</StatsCounter></GridColumn></GridRow></div>;
    $[33] = heroBadges;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== featureAbout) {
    t21 = featureAbout && <><GridRow className="bg-[#FFF] py-16 md:!py-20 lg:bg-[#F5F7F9]"><GridColumn lg={12}><div className="w-full max-w-[1240px] px-4 md:px-8 lg:mx-auto"><div className="mb-12 flex flex-col lg:items-center lg:text-center"><SuperTitle>{featureAbout?.eyebrow}</SuperTitle><h2 className="mt-4 font-semibold leading-tight text-[#373A36]">{featureAbout?.heading}</h2><p className="mt-4 leading-6 text-[#4A4A4A]">{featureAbout?.description}</p></div><GridRow className="items-stretch"><GridColumn lg={7}><VideoPlayerModal videoUrl={featureAbout?.videoCard?.videoUrl ?? ""} title={featureAbout?.heading}><div className="relative overflow-hidden rounded-[6px] shadow-lg">{featureAbout?.videoCard?.thumbnail?.asset && <Image src={imageUrl(featureAbout.videoCard.thumbnail.asset).url()} width={2560} height={1707} sizes="(width <= 768px) 1120px, 640px" alt="Watch our story" />}<div className="absolute left-1/2 top-1/2 flex items-center justify-center rounded-full text-white"><Image src="/Playbutton.svg" alt="playbutton" width="90" height="90" fetchPriority="high" loading={ImageLoading.EAGER} /></div><div className="absolute right-4 top-4 rounded-[8px] bg-[#002634C7] px-4 py-2 text-xs font-semibold uppercase text-white backdrop-blur-[4px]">Watch Our Story</div></div></VideoPlayerModal></GridColumn><GridColumn lg={5}><div className="flex h-full flex-col rounded-[6px] border border-[#D9D8D6] bg-white p-6"><h3 className="mb-4 font-lora font-semibold leading-8 text-[#005472]">{featureAbout?.sideContent?.title}</h3><p className="font-poppins mb-6 flex-1 leading-6 text-[#4A4A4A]">{featureAbout?.sideContent?.content}</p><Link href={featureAbout?.sideContent?.ctaLink ?? ""} className="rounded !bg-[#005E7A] py-3 text-center font-semibold !text-[#fff]">{featureAbout?.sideContent?.ctaText}</Link></div></GridColumn></GridRow></div></GridColumn></GridRow><GridRow className="!mt-10 lg:!mt-16"><GridColumn lg={12}><div className="max-w-[1240px] px-4 md:px-8 lg:mx-auto"><div className="mb-12 flex flex-col gap-4 md:mb-[72px] lg:items-center lg:text-center"><SuperTitle>{featureAbout?.benefitsEyebrow}</SuperTitle><h2 className="text-[#373A36]">{featureAbout?.benefitsHeading}</h2><p className="mx-auto leading-7 text-[#696B68]">{featureAbout?.benefitsDescription}</p></div><div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">{featureAbout?.benefits?.map(_temp5)}</div><div className="mt-12 grid gap-4 md:grid-cols-3">{featureAbout?.stats?.map(_temp6)}</div></div></GridColumn></GridRow></>;
    $[35] = featureAbout;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== execFeature || $[38] !== leadership) {
    t22 = leadership && execFeature && <GridRow className="!my-10 lg:!my-16"><GridColumn><LeadershipSection leadershipGrid={leadership} execFeature={execFeature} /></GridColumn></GridRow>;
    $[37] = execFeature;
    $[38] = leadership;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== testimonials) {
    t23 = testimonials && <GridRow><GridColumn><div className="mb-4 flex lg:items-center lg:justify-center"><SuperTitle>{testimonials?.eyebrow}</SuperTitle></div><HomeReviews data={testimonials} showStats={false} quoteShow={true} /></GridColumn></GridRow>;
    $[40] = testimonials;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== productsGrid) {
    t24 = productsGrid && <GridRow className="!my-10 lg:!my-16"><GridColumn><div className="flex flex-col gap-4 lg:mx-auto lg:items-center lg:justify-center lg:px-8 lg:text-center"><SuperTitle>{productsGrid?.eyebrow}</SuperTitle><h2 className="">{productsGrid.heading}</h2><p>{productsGrid?.subheading}</p></div></GridColumn>{productsGrid.items?.map(_temp7)}</GridRow>;
    $[42] = productsGrid;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== careerCtaText?.[0] || $[45] !== careerCtaText?.[1] || $[46] !== careersCta) {
    t25 = careersCta && <GridRow className="!mb-16"><GridColumn><div className="rounded-[6px] bg-[#005472] px-10 py-8 md:px-14 md:py-10"><div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center"><div><span className="mb-4 block text-[10px] font-semibold uppercase tracking-[1.5px] text-[#38D5C4]">{careersCta?.eyebrow}</span><h2 className="mb-3 text-[32px] font-semibold leading-[40px] text-white">{careerCtaText?.[0]}<span className="text-[#3BD4AE]">powerful</span>{careerCtaText?.[1]}</h2><p className="text-white/80">{careersCta?.subtext}</p></div><Link href={careersCta?.primaryCta?.link?.href ?? ""} className="flex shrink-0 items-center gap-2 rounded-full bg-white px-8 py-3 text-[14px] font-semibold text-[#005472] transition hover:bg-gray-100">{careersCta?.primaryCta?.link?.label}<span>→</span></Link></div></div></GridColumn></GridRow>;
    $[44] = careerCtaText?.[0];
    $[45] = careerCtaText?.[1];
    $[46] = careersCta;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t19 || $[49] !== t20 || $[50] !== t21 || $[51] !== t22 || $[52] !== t23 || $[53] !== t24 || $[54] !== t25) {
    t26 = <div className={t8}>{t19}{t20}{t21}{t22}{t23}{t24}{t25}</div>;
    $[48] = t19;
    $[49] = t20;
    $[50] = t21;
    $[51] = t22;
    $[52] = t23;
    $[53] = t24;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  return t26;
};
export default AboutUs;
function _temp(t0) {
  const {
    children
  } = t0;
  return <span className="text-[#009490]">{children}</span>;
}
function _temp2(item) {
  return item._type === "testimonialQuoteItem";
}
function _temp3(badge) {
  const label = badge.label ?? "";
  const numberMatch = label.match(/[\d,.]+/);
  const value = numberMatch ? Number(numberMatch[0].replace(/,/g, "")) : 0;
  const prefix = label.startsWith("$") ? "$" : "";
  const numericPart = numberMatch?.[0] ?? "";
  const suffix = label.replace(prefix, "").replace(numericPart, "").trim();
  return {
    value,
    prefix,
    suffix,
    label: badge.subheading ?? ""
  };
}
function _temp4(item_0, index) {
  return <div key={index} className="w-full min-w-[300px] rounded-[6px] bg-[#FFF] p-3 shadow-lg md:min-w-[400px]"><div className="mb-2 text-yellow-400">{"\u2605".repeat(5)}</div><div className="flex gap-4"><div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[linear-gradient(135deg,#3BD4AE_0%,#069590_100%)] text-white">{item_0.badge?.label}</div><div><p className="text-sm font-semibold text-[#005472]">"{item_0.quote}"</p><p className="mt-2 text-xs text-[#8D8D8D]">{item_0.author} ·{" "}<DateString date={item_0.date ?? ""} format={DateStringFormat.SLASHES} /></p></div></div></div>;
}
function _temp5(benefit) {
  return <div key={benefit._key}><div className="mb-4 h-[2px] w-6 bg-[#005472]" /><div className="mb-4 font-lora text-[18px] font-medium italic leading-[18px] tracking-[0.72px] text-[#005472]">{benefit.number}</div><h3 className="mb-4 font-lora text-[20px] font-semibold leading-[27px] text-[#005472]">{benefit.title}</h3><p className="text-[15px] font-normal leading-[24px] text-[#696B68]">{benefit.description}</p></div>;
}
function _temp6(stat) {
  return <div key={stat._key} className="flex gap-3 rounded-[6px] bg-[#005472] px-6 py-5 text-white md:items-start">{stat?.Image?.asset && <Image src={imageUrl(stat?.Image?.asset).width(20).url()} className="mt-1 shrink-0" alt="" width={20} height={20} fetchPriority="high" loading={ImageLoading.EAGER} />}<span className="leading-[23px]">{stat.text}</span></div>;
}
function _temp7(item_2, index_1) {
  const {
    cta,
    icon,
    summary,
    title
  } = item_2;
  if (!cta?.link || !icon || !summary || !title) {
    return null;
  }
  return <GridColumn key={index_1} lg={4} className="mt-5 lg:mt-14"><Card description={summary} imgUrl={icon?.asset ? imageUrl(icon?.asset).width(58).url() : undefined} linkLabel={cta.link.label} linkUrl={cta.link.href ?? "/"} title={title} hoverEffect={true} imgWidth={58} imgHeight={58} ctaId={cta?.link?.ctaId ?? ""} ctaValue={cta?.link?.ctaValue ?? ""} relValue={cta?.link?.nofollow} className="px-8" /></GridColumn>;
}